export const getDefaultAvatarSrc = (id: string) =>
  `/api/default-avatar?id=${id}`
